import React from 'react';
import {Provider} from 'react-redux';
import {renderElement} from '@Utils/root-element.util';
import {EmailMakerAiTextPromptBox} from '@Components/email-maker-ai-text-prompt-box';

window.PMW.mergePMW(PMW, {
  renderAiRewritePromptBox(containerElement: HTMLElement, opts: any) {
    renderElement(
      containerElement,
      <Provider store={window.PMW.redux.store}>
        <EmailMakerAiTextPromptBox {...opts} />
      </Provider>
    );
  },
});
